import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router, RouterModule } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { PageBreadcrumbComponent } from '../../../shared/components/common/page-breadcrumb/page-breadcrumb.component';
import { BadgeComponent } from '../../../shared/components/ui/badge/badge.component';
import { ContactAttributeDefinitionApiService } from '../services/contact-attribute-definition-api.service';
import { ContactAttributeDefinitionResponse } from '../models/contact-attribute-definition.model';
import { AuthService } from '../../auth-pages/services/auth.service';
import { ConfirmDialogService } from '../../../shared/services/confirm-dialog.service';
import { ToastService } from '../../../shared/services/toast.service';
import { HasPermissionDirective } from '../../../shared/directives/has-permission.directive';

type BadgeColor = 'primary' | 'success' | 'error' | 'warning' | 'info' | 'light' | 'dark';

@Component({
  selector: 'app-contact-attribute-definition-list',
  standalone: true,
  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
    PageBreadcrumbComponent,
    BadgeComponent,
    HasPermissionDirective
  ],
  templateUrl: './contact-attribute-definition-list.component.html'
})
export class ContactAttributeDefinitionListComponent implements OnInit {
  definiciones: ContactAttributeDefinitionResponse[] = [];
  loading = false;
  error = '';

  constructor(
    private definitionApi: ContactAttributeDefinitionApiService,
    private authService: AuthService,
    private router: Router,
    private confirmDialog: ConfirmDialogService,
    private toast: ToastService
  ) { }

  ngOnInit(): void {
    this.cargarDefiniciones();
  }

  cargarDefiniciones(): void {
    this.loading = true;
    this.error = '';

    const user = this.authService.getCurrentUser();
    const businessId = user?.businessId || 1;

    this.definitionApi.getDefinitions(businessId).subscribe({
      next: (data) => {
        this.definiciones = data;
        this.loading = false;
      },
      error: (err) => {
        this.error = err.error?.message || 'Error al cargar las definiciones de atributo';
        this.loading = false;
        console.error('Error:', err);
      }
    });
  }

  nuevaDefinicion(): void {
    this.router.navigate(['/config-contactos/definiciones/crear']);
  }

  editarDefinicion(def: ContactAttributeDefinitionResponse): void {
    this.router.navigate(['/config-contactos/definiciones/editar', def.id]);
  }

  async eliminarDefinicion(def: ContactAttributeDefinitionResponse): Promise<void> {
    const ok = await this.confirmDialog.confirmDanger({
      title: 'Eliminar definición',
      message: `¿Está seguro de eliminar la definición "${def.name}"?`
    });
    if (!ok) return;
    this.definitionApi.deleteDefinition(def.id).subscribe({
      next: () => {
        this.cargarDefiniciones();
        this.toast.deleted('Definición de atributo', `Se eliminó "${def.name}" correctamente.`);
      },
      error: (err) => {
        this.toast.error({ title: 'Error', message: err.error?.message || 'Error al eliminar la definición' });
      }
    });
  }

  getTypeColor(type: string): BadgeColor {
    const colors: Record<string, BadgeColor> = {
      text: 'info',
      number: 'warning',
      boolean: 'primary',
      list: 'success'
    };
    return colors[type] ?? 'dark';
  }

  getTypeLabel(type: string): string {
    const labels: Record<string, string> = {
      text: 'Texto',
      number: 'Número',
      boolean: 'Booleano',
      list: 'Lista'
    };
    return labels[type] ?? type;
  }

  getActiveColor(isActive: boolean): BadgeColor {
    return isActive ? 'success' : 'error';
  }

  getActiveLabel(isActive: boolean): string {
    return isActive ? 'Activo' : 'Inactivo';
  }
}
